import styles from './VerifyOtpPage.module.scss';
import popClose from '../../../../assets/images/pop-close.svg';
import contry from '../../../../assets/images/kuwait-flag.png';
import React, { useState, useEffect, useRef, useReducer } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { verifyOtpAction } from '../../../../stores/_actions';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import Validator from '../../../common/common-functions';

import ModalExampleCloseIcon from '../../../components/modal/Modal';
import Timer from '../../components/timer/Timer';

function VerifyOtp() {
  const history = useHistory();
  let customer;
  let customerCode;
  const jsonData = localStorage.getItem('customer');
  customer = JSON.parse(jsonData);
  customerCode = customerCode == null ? null : localStorage.getItem('CustomerCode');
  customerCode = JSON.parse(customerCode);
  const textInputRef = useRef(null);

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: customerCode,
    Data: {
      Module: 'RegDivice',
      DeviceID: customer?.DeviceID,
      DeviceType: customer?.DeviceType,
      IDNO: customer?.IDNO,
      MobileNo: customer?.MobileNo,
      OTP: '',
    },
    Status: false,
    SessionID: null,
    IdType: null,
    Langcode: '0001',
  };
  const [pass, setPin] = useState({
    OTP: '',
  });
  const [submitted, setSubmitted] = useState(false);
  let verify;
  useSelector((state) => {
    verify = state.verify?.data;
  }, []);
  const [hide, setN] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (textInputRef.current) {
      textInputRef.current.focus();
    }
    resendOtp();
  }, []);

  let errorMsg = '';
  const handleChange = (e) => {
    setPin((pass) => ({ ...pass, errorMsg: '' }));
    const { name, value } = e.target;
    if (name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six') {
      const checkValidpass = Validator.digitsOnly(value);
      if (!checkValidpass) {
        errorMsg = 'Only digits allowed';
        setPin((pass) => ({ ...pass, [name]: '' }));
        setPin((pass) => ({ ...pass, errorMsg: errorMsg }));
        return;
      }
    }
    setPin((pass) => ({ ...pass, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (pass.one && pass.two && pass.three && pass.four && pass.five && pass.six) {
      payload.Data['OTP'] = `${pass.one}${pass.two}${pass.three}${pass.four}${pass.five}${pass.six}`;
      dispatch(verifyOtpAction.verifyOtp(payload));
    } else {
      return;
    }
    // if (verify && verify.statusCode == '200') {
    //   setN(true);
    //   pass.one = '';
    //   pass.two = '';
    //   pass.three = '';
    //   pass.four = '';
    //   pass.five = '';
    //   pass.six = '';
    // }
  };

  const [time, setTime] = useState();
  const resendOtp = () => {
    // e.preventDefault();
    const payload = {
      Id: null,
      Message: null,
      CustomerCode: JSON.parse(customerCode),
      Data: {
        MobileNo: customer?.MobileNo,
      },
      Status: false,
      SessionID: null,
      IdType: null,
      FileType: null,
      Langcode: null,
    };
    setTime(20);
    dispatch(verifyOtpAction.generateOtp(payload));
  };

  const hidePopup = () => setN(false);
  const useMountEffect = (fun) => useEffect(fun, []);
  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [input1Val, setInput1Val] = useState('');
  const [input2Val, setInput2Val] = useState('');
  const [input3Val, setInput3Val] = useState('');
  const [input4Val, setInput4Val] = useState('');
  const [input5Val, setInput5Val] = useState('');
  const [input6Val, setInput6Val] = useState('');
  const [input1Ref, setInput1Focus] = UseFocus();
  const [input2Ref, setInput2Focus] = UseFocus();
  const [input3Ref, setInput3Focus] = UseFocus();
  const [input4Ref, setInput4Focus] = UseFocus();
  const [input5Ref, setInput5Focus] = UseFocus();
  const [input6Ref, setInput6Focus] = UseFocus();
  const [completeBtnRef, setCompleteFocus] = UseFocus();

  useMountEffect(setInput1Focus);
  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>Verify OTP</h1>
          <p>
            We have sent an OTP to +{`${customer?.MobileNo?.substring(0, 3)}${customer?.MobileNo?.substring(3)}`}. Validate your mobile number by
            entering the OTP below.
          </p>
          <form name="verify" id="frm" onSubmit={handleSubmit}>
            <div className={styles.LoginPage__formgroup}>
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="1"
                name="one"
                autoComplete="off"
                ref={textInputRef}
                value={pass.one}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput1Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput2Focus();
                }}
                ref={input1Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="2"
                name="two"
                autoComplete="none"
                value={pass.two}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput2Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput3Focus();
                }}
                ref={input2Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="3"
                name="three"
                autoComplete="none"
                value={pass.three}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput3Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput4Focus();
                }}
                ref={input3Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="4"
                name="four"
                autoComplete="none"
                value={pass.four}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput4Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput5Focus();
                }}
                ref={input4Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="5"
                name="five"
                autoComplete="off"
                value={pass.five}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput5Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput6Focus();
                }}
                ref={input5Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="6"
                name="six"
                autoComplete="none"
                value={pass.six}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput6Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input6Ref}
              />
              <div className={styles.formgroup__error}>{pass.errorMsg}</div>
              {submitted && !(pass.one && pass.two && pass.three && pass.four && pass.five && pass.six) && (
                <div className={styles.formgroup__error}>OTP is required</div>
              )}
              {verify && verify.statusCode != 200 && <div className={styles.formgroup__error}>{verify.message}</div>}
            </div>
            <input
              type="button"
              value="Back"
              className={styles.LoginPage__link}
              onClick={() => {
                history.push('/');
              }}
              style={{ width: '25%', marginRight: '10px' }}
            />
            <button
              onClick={handleSubmit}
              value={Label.VerifyOtp.buttonLabel}
              className={styles.LoginPage__link}
              style={{ width: '25%', marginRight: '10px' }}
            >
              {Label.VerifyOtp.buttonLabel}
            </button>
            {/* <ModalExampleCloseIcon open={verify && verify.statusCode == '406' ? hide : false} /> */}
          </form>
          <p className={styles.LoginPage__alrmember}>
            Haven't received OTP?
            <br />
            <a>
              <Timer resendOtp={resendOtp} />
            </a>
          </p>
          <p className={styles.LoginPage__alrmember}>
            Already Registered? <Link to="/">Login!</Link>
          </p>
        </div>
      </div>

      {hide ? (
        <div className={styles.dialogue}>
          <div className={styles.dialogue__wrap}>
            <img className={styles.dialogue__close} src={popClose} onClick={hidePopup} />
            {/* <p>{verify?.message}</p> */}
            <p>It looks like your have not registered with us before. Please click below to register with before proceeding ahead.</p>
            <div className={styles.dialogue__buttons}>
              <Link to="/add-customer" className={styles.LoginPage__link}>
                Add Your Details
              </Link>
              {/* <input type="submit" value={Label.VerifyOtp.buttonOkLabel} onClick={hidePopup} className={styles.LoginPage__link} /> */}
              {/* <input type="submit" value={Label.VerifyOtp.buttonCancelLabel} onClick={hidePopup} className={styles.LoginPage__link} /> */}
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </LoadingIndicator>
  );
}
export { VerifyOtp };
